// English translations
export const en = {
  // Navigation
  navigation: {
    dashboard: 'Dashboard',
    inventory: 'Inventory',
    market: 'Market',
    production: 'Production',
    brands: 'Brands',
    copyright: 'Copyright',
    employees: 'Employees',
    machinery: 'Machinery',
    productRequests: 'Add Product Request',
    cryptoWallet: 'Crypto Wallet',
    gameTitle: 'Business Tycoon Game'
  },

  // Dashboard
  dashboard: {
    title: 'Welcome to Business Tycoon Game',
    subtitle: 'Start your economic journey',
    cashBalance: 'Cash Balance',
    playerLevel: 'Player Level',
    experience: 'Experience',
    production: 'Product Production',
    productionSubtitle: 'Produce new products',
    market: 'Market',
    marketSubtitle: 'Sell your products',
    brands: 'Your Brands',
    brandsSubtitle: 'Manage personal brands',
    copyright: 'Copyright',
    copyrightSubtitle: 'Protect your products',
    employees: 'Your Employees',
    employeesSubtitle: 'Manage human resources',
    machinery: 'Machinery',
    machinerySubtitle: 'Manage equipment',
    aiRequests: 'Add Product Request',
    aiRequestsSubtitle: 'Request to add new product to the system',
    recentActivity: 'Recent Activity',
    recentActivitySubtitle: 'Your latest actions',
    viewAll: 'View All',
    produce: 'Produce',
    sell: 'Sell',
    manage: 'Manage',
    goldenBrand: 'Golden Brand',
    reputation: 'Reputation',
    barbariBread: 'Barbari Bread',
    specialBarbariBread: 'Special Barbari Bread',
    requests: 'Requests',
    ahmadMohammadi: 'Ahmad Mohammadi',
    level: 'Level',
    breadMachine: 'Bread Production Machine',
    excellent: 'Excellent',
    gameStart: 'Start Game',
    accountCreated: 'Your account has been created',
    reachedLevel1: 'You have reached level 1',
    now: 'Now'
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    date: 'Date',
    time: 'Time',
    status: 'Status',
    name: 'Name',
    description: 'Description',
    price: 'Price',
    quantity: 'Quantity',
    total: 'Total',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    select: 'Select',
    required: 'Required',
    optional: 'Optional',
    player: 'Player',
    personal: 'Personal',
    cancel: 'Cancel'
  },

  // Auth
  auth: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password',
    rememberMe: 'Remember Me',
    welcomeBack: 'Welcome Back',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?"
  },

  // Copyright
  copyright: {
    title: 'Copyright Management',
    subtitle: 'Manage your copyright requests',
    selectProduct: 'Select Product',
    selectBrand: 'Select Brand',
    requestMessage: 'Request Message',
    status: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    createdAt: 'Created At',
    reviewedAt: 'Reviewed At',
    adminResponse: 'Admin Response',
    yourRequests: 'Your Requests',
    requests: 'request',
    protectProducts: 'Protect your products with copyright',
    noRequests: 'No requests found',
    createRequest: 'New Copyright Request',
    createRequestSubtitle: 'Request copyright for your product',
    yourRequestsSubtitle: 'List of all your requests',
    requestMessagePlaceholder: 'Enter your copyright request description',
    createFirstRequest: 'Submit First Request',
    benefits: 'Copyright Benefits',
    legalProtection: 'Legal Protection',
    legalProtectionDescription: 'Protect your products from illegal copying',
    additionalRevenue: 'Additional Revenue',
    additionalRevenueDescription: 'Receive royalties from those who copy your product',
    brandCredibility: 'Brand Credibility',
    brandCredibilityDescription: 'Copyright increases your brand credibility and value',
    legalRight: 'Legal Right',
    legalRightDescription: 'Have the exclusive right to use your product'
  },

  // Brands
  brands: {
    title: 'Brand Management',
    subtitle: 'Manage your personal brands',
    createBrand: 'Create New Brand',
    createBrandSubtitle: 'Define your new brand',
    brandName: 'Brand Name',
    brandNamePlaceholder: 'Enter your brand name',
    brandDescription: 'Brand Description',
    brandDescriptionPlaceholder: 'Enter your brand description',
    reputation: 'Reputation',
    createdAt: 'Created At',
    yourBrands: 'Your Brands',
    yourBrandsSubtitle: 'List of created brands',
    brands: 'brand',
    excellent: 'Excellent',
    good: 'Good',
    average: 'Average',
    poor: 'Poor',
    viewProducts: 'View Products',
    noBrands: 'No brands found',
    createFirstBrand: 'To get started, create your first brand.',
    brandCreated: 'Brand created successfully!',
    brandError: 'Error creating brand',
    fillRequiredFields: 'Please enter the brand name'
  },

  // Employees
  employees: {
    title: 'Employee Management',
    subtitle: 'Manage your employees',
    yourEmployees: 'Your Employees',
    people: 'people',
    totalSalary: 'Total Salary',
    production: 'Production',
    sales: 'Sales',
    management: 'Management',
    general: 'General',
    skillLevel: 'Skill Level',
    salary: 'Salary',
    experience: 'Experience',
    efficiency: 'Efficiency',
    hiredAt: 'Hired At',
    fire: 'Fire',
    hire: 'Hire',
    selectEmployee: 'Select Employee',
    noEmployees: 'No employees found',
    hireNewEmployee: 'Hire New Employee',
    hireNewEmployeeSubtitle: 'Choose from available employees',
    yourEmployeesSubtitle: 'List of all employees',
    statistics: '📊 Employee Statistics',
    statisticsSubtitle: 'General employee information',
    benefits: 'Benefits of Hiring Employees',
    noEmployeesMessage: 'You can increase your efficiency by hiring employees',
    hireFirstEmployee: 'Hire First Employee',
    employeeCount: 'Employee Count',
    averageEfficiency: 'Average Efficiency',
    productionWorkers: 'Production Workers',
    efficiencyBoost: 'Efficiency Boost',
    efficiencyBoostDescription: 'Employees increase your production and sales efficiency',
    specialization: 'Specialization',
    specializationDescription: 'Each employee specializes in a specific field',
    experienceGrowth: 'Experience Growth',
    experienceGrowthDescription: 'Employees gain more experience over time',
    moreProfit: 'More Profit',
    moreProfitDescription: 'Higher efficiency leads to more profit'
  },

  // Machinery
  machinery: {
    title: 'Machinery Shop',
    subtitle: 'Manage your machinery',
    yourMachinery: 'Your Machinery',
    devices: 'devices',
    allTypes: 'All Types',
    production: 'Production',
    transport: 'Transport',
    storage: 'Storage',
    yourMachineryList: 'Your Machinery',
    yourMachinerySubtitle: 'List of purchased machinery',
    noMachinery: 'No machinery purchased yet',
    noMachineryMessage: 'Increase your efficiency by purchasing machinery',
    efficiency: 'Efficiency',
    maintenanceCost: 'Maintenance Cost',
    condition: 'Condition',
    repair: 'Repair',
    details: 'Details',
    level: 'Level',
    requiredLevel: 'Required Level',
    price: 'Price',
    insufficientFunds: 'Insufficient funds',
    insufficientLevel: 'Insufficient level',
    buy: 'Buy',
    statistics: '📊 Machinery Statistics',
    statisticsSubtitle: 'General machinery information',
    deviceCount: 'Device Count',
    totalValue: 'Total Value',
    productionDevices: 'Production Devices',
    benefits: 'Machinery Benefits',
    benefitsSubtitle: 'Why should you buy machinery?',
    efficiencyBoost: 'Efficiency Boost',
    efficiencyBoostDescription: 'Machinery increases production and transport efficiency',
    costReduction: 'Cost Reduction',
    costReductionDescription: 'Machinery reduces production and transport costs',
    betterQuality: 'Better Quality',
    betterQualityDescription: 'Advanced machinery improves product quality',
    scalability: 'Scalability',
    scalabilityDescription: 'With machinery you can expand your production',
    shop: 'Machinery Shop',
    buyNewMachinery: 'Buy new machinery',
    excellent: 'Excellent',
    good: 'Good',
    average: 'Average',
    poor: 'Poor',
  },

  // Production
  production: {
    title: 'Production',
    loading: 'Loading...',
    startNewProduction: 'Start New Production',
    startNewProductionSubtitle: 'Produce new products',
    selectProduct: 'Select Product',
    seconds: 'seconds',
    productionInfo: 'Production Info',
    product: 'Product',
    price: 'Price',
    productionTime: 'Production Time',
    requiredLevel: 'Required Level',
    startProduction: 'Start Production',
    activeProductions: '🔄 Active Productions',
    activeProductionsSubtitle: 'Ongoing productions',
    quantity: 'Quantity',
    timeRemaining: 'Time Remaining',
    collect: 'Collect',
    waiting: 'Waiting',
    noActiveProductions: 'No active productions',
    noActiveProductionsMessage: 'Start producing products!',
    availableProducts: '📋 Available Products',
    availableProductsSubtitle: 'List of all producible products',
    category: 'Category',
    food: 'Food',
    electronics: 'Electronics',
    materials: 'Materials',
    textiles: 'Textiles',
    chemicals: 'Chemicals',
    construction: 'Construction'
  },

  // Market
  market: {
    title: 'Market',
    loading: 'Loading...',
    subtitle: 'Sell your products to shops',
    demand: 'Demand',
    location: 'Location',
    sellableProducts: 'Sellable Products',
    shop: 'Shop',
    basePrice: 'Base Price',
    shopInterest: 'Shop Interest',
    priceMultiplier: 'Price Multiplier',
    sell: 'Sell',
    noProducts: 'This shop doesn\'t buy any products',
    statistics: 'Market Statistics',
    statisticsSubtitle: 'General market information',
    activeShops: 'Active Shops',
    averageDemand: 'Average Demand',
    sellableProductsCount: 'Sellable Products'
  },

  // Inventory
  inventory: {
    title: 'Inventory',
    subtitle: 'Your produced goods',
    unknownProduct: 'Unknown Product',
    quality: 'Quality',
    quantity: 'Quantity',
    sell: 'Sell',
    details: 'Details',
    emptyInventory: 'Inventory is empty',
    emptyInventoryMessage: 'You don\'t have any goods in inventory yet. Start producing!',
    startProduction: 'Start Production'
  },

  // Product Requests
  productRequests: {
    title: 'Add Product Request',
    subtitle: 'Request to add new product to the system',
    newRequest: 'New Product Request',
    newRequestSubtitle: 'Enter details for your new product',
    productName: 'Product Name',
    productNamePlaceholder: 'e.g., Special Barbari Bread',
    category: 'Category',
    selectCategory: 'Select Category',
    targetPrice: 'Target Price',
    targetPricePlaceholder: 'Suggested product price',
    description: 'Description',
    descriptionPlaceholder: 'Complete product description',
    requiredMaterials: 'Required Materials',
    requiredMachinery: 'Required Machinery',
    productionProcess: 'Production Process',
    productionProcessPlaceholder: 'Product production steps in order',
    estimatedProductionTime: 'Estimated Production Time',
    estimatedProductionTimePlaceholder: 'Time required for production (minutes)',
    submitRequest: 'Submit Request',
    fillRequiredFields: 'Please fill in all required fields',
    addAtLeastOneMaterial: 'Please add at least one material',
    addAtLeastOneMachinery: 'Please add at least one machinery',
    requestSubmitted: 'Your request has been submitted successfully!',
    submitError: 'Error submitting request',
    yourRequests: 'Your Requests',
    yourRequestsSubtitle: 'List of submitted requests',
    totalRequests: 'Total Requests',
    approvedRequests: 'Approved Requests',
    pending: 'Pending',
    underReview: 'Under Review',
    approved: 'Approved',
    rejected: 'Rejected',
    createdAt: 'Created At',
    reviewedAt: 'Reviewed At',
    adminNotes: 'Admin Notes',
    minutes: 'minutes',
    noRequests: 'No requests found',
    selectExistingMaterial: 'Select Existing Material',
    selectMaterial: 'Select Material',
    materialName: 'Material Name',
    materialNamePlaceholder: 'Material name',
    quantity: 'Quantity',
    unit: 'Unit',
    unitPlaceholder: 'kg, liter, piece',
    addMaterial: 'Add Material',
    selectExistingMachinery: 'Select Existing Machinery',
    selectMachinery: 'Select Machinery',
    machineryName: 'Machinery Name',
    machineryNamePlaceholder: 'Machinery name',
    addMachinery: 'Add Machinery',
    new: 'New',
    food: 'Food',
    electronics: 'Electronics',
    materials: 'Materials',
    textiles: 'Textiles',
    chemicals: 'Chemicals',
    construction: 'Construction'
  },

  // Crypto Wallet
  crypto: {
    title: 'Cryptocurrency System',
    subtitle: 'Manage wallets and personal tokens',
    wallets: 'Wallets',
    tokens: 'Tokens',
    transactions: 'Transactions',
    staking: 'Staking',
    createWallet: 'Create Wallet',
    createToken: 'Create Token',
    yourWallets: 'Your Wallets',
    walletsSubtitle: 'List of personal wallets',
    yourTokens: 'Your Tokens',
    tokensSubtitle: 'List of created tokens',
    yourTransactions: 'Your Transactions',
    transactionsSubtitle: 'Transaction history',
    stakingPools: 'Staking Pools',
    stakingSubtitle: 'Stake tokens to earn rewards',
    noWallets: 'No wallet created yet',
    noWalletsMessage: 'To get started, create a new wallet.',
    noTokens: 'No token created yet',
    noTokensMessage: 'To get started, create a new token.',
    noTransactions: 'No transactions found',
    noTransactionsMessage: 'You haven\'t made any transactions yet.',
    walletName: 'Wallet Name',
    walletNamePlaceholder: 'Enter your wallet name',
    tokenName: 'Token Name',
    tokenNamePlaceholder: 'Enter your token name',
    tokenSymbol: 'Token Symbol',
    tokenSymbolPlaceholder: 'e.g., BTC, ETH',
    totalSupply: 'Total Supply',
    totalSupplyPlaceholder: 'Total number of tokens',
    walletCreated: 'Wallet created successfully!',
    tokenCreated: 'Token created successfully!',
    walletError: 'Error creating wallet',
    tokenError: 'Error creating token',
    balance: 'Balance',
    address: 'Address',
    symbol: 'Symbol',
    supply: 'Supply',
    price: 'Price',
    marketCap: 'Market Cap',
    volume: 'Volume',
    change24h: '24h Change',
    buy: 'Buy',
    sell: 'Sell',
    transfer: 'Transfer',
    stake: 'Stake',
    unstake: 'Unstake',
    amount: 'Amount',
    amountPlaceholder: 'Enter amount',
    recipient: 'Recipient',
    recipientPlaceholder: 'Recipient address',
    stakeAmount: 'Stake Amount',
    stakeAmountPlaceholder: 'Amount of tokens to stake',
    stakePeriod: 'Stake Period',
    stakePeriodPlaceholder: 'Days',
    apy: 'APY',
    totalStaked: 'Total Staked',
    yourStake: 'Your Stake',
    rewards: 'Rewards',
    claimRewards: 'Claim Rewards',
    walletBalance: 'Wallet Balance',
    totalValue: 'Total Value',
    portfolio: 'Portfolio',
    portfolioSubtitle: 'Overview of your investments',
    fillRequiredFields: 'Please fill in all required fields',
    createWalletSubtitle: 'Create your new wallet',
    createTokenSubtitle: 'Create your new token',
    transferSubtitle: 'Transfer tokens to another wallet',
    selectToken: 'Select Token',
    tokenDescription: 'Token Description',
    tokenDescriptionPlaceholder: 'Enter your token description',
    initialPrice: 'Initial Price',
    initialPricePlaceholder: 'Initial token price',
    tokenLogoUrl: 'Token Logo URL',
    tokenLogoUrlPlaceholder: 'Token logo image URL',
    viewDetails: 'View Details',
    selectWalletFirst: 'Please select a wallet first',
    stakingComingSoon: 'Staking Coming Soon',
    stakingDescription: 'Token staking functionality will be added soon',
    transferSuccess: 'Transfer completed successfully!',
    transferError: 'Error transferring'
  }
}